export default class VerticalCarriage {
  static init(node) {
    if (!node) {
      return null;
    }
    return new VerticalCarriage(node);
  }

  constructor(node) {
    this.selectors = {
      tabBtnSelector: '[data-tab-control]',
      carriageContentSelector: '[data-tab-carriage-content]',
      carriageSelector: '[data-tab-carriage]',
    };

    this.els = {
      tabsContainer: node,
      tabs: [...node.querySelectorAll(this.selectors.tabBtnSelector)],
      carriageContentBlocks: [
        ...node.querySelectorAll(this.selectors.carriageContentSelector),
      ],
      carriage: node.querySelector(this.selectors.carriageSelector),
    };

    const { tabs } = this.els;

    this.currentTab = tabs[0];
    this.activeClassName = 'active-tab-1';

    this.addEventListeners();
    this.setCarriagePosition(this.currentTab);
  }

  UpdateActiveClassName(tab) {
    const { tabsContainer } = this.els;

    if (tab) {
      tab.classList.forEach((className) => {
        if (className.startsWith('active-tab-')) {
          this.activeClassName = className;
        }
      });
    } else {
      tabsContainer.closest('section').classList.forEach((className) => {
        if (className.startsWith('active-tab-')) {
          this.activeClassName = className;
        }
      });
    }
  }

  getCurrentTab() {
    const { tabs } = this.els;

    tabs.forEach((currentTab) => {
      if (currentTab.classList.contains(this.activeClassName)) {
        this.currentTab = currentTab;
      }
    });
  }

  setCarriagePosition(tab) {
    const { carriage, carriageContentBlocks } = this.els;
    let tabHeight = 0;

    carriageContentBlocks.forEach((carriageContent) => {
      if (
        carriageContent.parentElement.classList.contains(this.activeClassName)
      ) {
        tabHeight = carriageContent.offsetHeight;
      }
    });

    if (this.currentTab !== tab) {
      this.currentTab.style.minHeight = '0px';
    }

    const tabOffsetTop = tab.offsetTop;

    tab.style.minHeight = `${tabHeight + 85}px`;
    carriage.style.top = `${tabOffsetTop}px`;
    carriage.style.height = `${tabHeight + 50}px`;
  }

  addEventListeners() {
    const { tabBtnSelector } = this.selectors;
    const { tabsContainer } = this.els;

    tabsContainer.addEventListener('click', (event) => {
      event.preventDefault();
      const tab = event.target.closest(tabBtnSelector);

      if (tab) {
        this.UpdateActiveClassName(tab);
        this.setCarriagePosition(tab);
        this.currentTab = tab;
      }
    });

    window.addEventListener('resize', () => {
      this.UpdateActiveClassName();
      this.getCurrentTab();
      this.setCarriagePosition(this.currentTab);
    });
  }
}
